import { useState } from 'react';
import { endOfDay, format, startOfDay, subDays } from 'date-fns';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useLazyGetExtractV2Query } from '../../services/extractApi';
import { useFormatExtract } from '../useFormatExtract';
export function useGetExtract(canSeeStatements) {
    const { toExtract } = useFormatExtract();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const [triggerV2] = useLazyGetExtractV2Query();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [extract, setExtract] = useState();
    async function getExtract(flow, type, startAt, endAt, minAmount, maxAmount) {
        if (!canSeeStatements) {
            setLoading(false);
            setError(false);
            setLoadError(false);
            setExtract(undefined);
            return;
        }
        setLoading(true);
        setError(false);
        setLoadError(false);
        setExtract(undefined);
        const isBaasV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
        try {
            const { data, error: queryError } = await triggerV2({
                flow,
                types: type,
                startAt: startAt ?? format(startOfDay(subDays(new Date(), 29)), 'yyyy-MM-dd'),
                endAt: endAt ?? format(endOfDay(new Date()), 'yyyy-MM-dd'),
                minAmount,
                maxAmount,
                isBaasV2Enabled,
            }, false);
            if (queryError || !data) {
                setError(true);
                setLoadError(true);
                return;
            }
            const statements = data.result?.statements ?? [];
            if (statements.length) {
                setExtract(toExtract(statements, data?.result?.dailyBalance));
            }
            else {
                setError(true);
            }
        }
        catch {
            setError(true);
            setLoadError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return { loading, setLoading, error, setError, loadError, extract, setExtract, getExtract };
}
